export const GeographyMarketList = [
    "Urban", "Suburban", "Rural"
]